import {reactLocalStorage} from "reactjs-localstorage" 
var ApiHelper = {}
// ApiHelper.baseURL = "https://technodds-website.uc.r.appspot.com/api/v1/"
ApiHelper.baseURL = "https://stock-management.azurewebsites.net/api/v1/"
// ApiHelper.baseURL = "http://192.168.0.102:4000/api/v1/"
//Scraper
ApiHelper.scraper = {}
ApiHelper.scraper.getMarketMoodIndex = ApiHelper.baseURL + "scraper/getmmi"
ApiHelper.scraper.getNifty = ApiHelper.baseURL + "scraper/getnifty50"
ApiHelper.scraper.getSensex = ApiHelper.baseURL + "scraper/getsensex"
//Companies
ApiHelper.companies = {}
ApiHelper.companies.getNumberOfCompanies = ApiHelper.baseURL + "companies/getnumberofcompanies"
//Credentials
ApiHelper.credentials = {}
ApiHelper.credentials.addCredential = ApiHelper.baseURL + "credentials/adddevelopercredentials"
ApiHelper.credentials.getCredentialsByOffset = ApiHelper.baseURL + "credentials/getcredentialsbyoffset"
ApiHelper.credentials.updateSuperAdminStatus = ApiHelper.baseURL + "credentials/updatesuperadminstatus"
ApiHelper.credentials.deleteCredential = ApiHelper.baseURL + "credentials/deletedevelopercredentials"
//Common
ApiHelper.common = {}
ApiHelper.common.getSummary = ApiHelper.baseURL + "common/getsummary"

ApiHelper.companies.getCompanyNamesByOffset = ApiHelper.baseURL + "companies/getcompanynamesbyoffset"
ApiHelper.companies.getCompaniesByOffset = ApiHelper.baseURL + "companies/getcompaniesbyoffset"
ApiHelper.companies.getCompanySpecific = ApiHelper.baseURL + "companies/getcompanyspecific"
ApiHelper.companies.getCompaniesCount = ApiHelper.baseURL + "companies/getcompaniescount"
ApiHelper.companies.addCompany = ApiHelper.baseURL + "companies/addcompany"
ApiHelper.companies.removeCompany = ApiHelper.baseURL + "companies/removecompany"
ApiHelper.companies.updateCompany = ApiHelper.baseURL + "companies/updatecompany"
ApiHelper.companies.getTopRecommendations = ApiHelper.baseURL + "companies/gettoprecommendations"
ApiHelper.companies.getArthSortedCompaniesByOffset = ApiHelper.baseURL + "companies/getarthsortedcompaniesbyoffset"
ApiHelper.companies.getArthSortedCompaniesBySearchKey = ApiHelper.baseURL + "companies/getarthsortedcompaniesbysearchkey"
ApiHelper.companies.getRelevanceSortedCompaniesByOffset = ApiHelper.baseURL + "companies/getrelevancesortedcompaniesbyoffset"
ApiHelper.companies.getTargetDifferenceSortedCompaniesByOffset = ApiHelper.baseURL + "companies/gettargetdifferencesortedcompaniesbyoffset"
ApiHelper.companies.getAlphabeticalSortedCompaniesByOffset = ApiHelper.baseURL + "companies/getalphabeticalsortedcompaniesbyoffset"
ApiHelper.companies.getLeastRelevantCompany = ApiHelper.baseURL + "companies/getleastrelevantcompany"
//Alphavantage
ApiHelper.alphaVantage = {}
ApiHelper.alphaVantage.searchSymbol = ApiHelper.baseURL + "alphavantage/searchsymbol"
ApiHelper.alphaVantage.getDailyStockHistory = ApiHelper.baseURL + "alphavantage/getdailystockhistory"

//DeveloperCredentials
ApiHelper.developerCredentials = {}
ApiHelper.developerCredentials.login = ApiHelper.baseURL + "developercredentials/login"
ApiHelper.developerCredentials.initDeveloperPortal = ApiHelper.baseURL + "developercredentials/initdeveloperportal"

//brokerRecos
ApiHelper.brokerRecos = {}
ApiHelper.brokerRecos.getLastFetchedLog = ApiHelper.baseURL + "brokerrecos/getlastfetchedlog"
ApiHelper.brokerRecos.getRecommendationsByOffset = ApiHelper.baseURL + "brokerrecos/getrecommendationsbyoffset"
ApiHelper.brokerRecos.refreshRecommendations = ApiHelper.baseURL + "brokerrecos/refreshrecommendations"
ApiHelper.brokerRecos.updateRecommendationSymbols = ApiHelper.baseURL + "brokerrecos/updaterecommendationssymbols"
ApiHelper.brokerRecos.updateOrders = ApiHelper.baseURL + "brokerrecos/updateorders"
ApiHelper.brokerRecos.getUnidentifiedCompaniesByOffset = ApiHelper.baseURL + "brokerrecos/getunidentifiedcompaniesbyoffset"
ApiHelper.brokerRecos.deleteAllUnidentifiedCompanies = ApiHelper.baseURL + "brokerrecos/deleteallunidentifiedcompanies"
ApiHelper.brokerRecos.startRecommendationsAutoUpdate = ApiHelper.baseURL + "brokerrecos/startrecommendationsautoupdate"
ApiHelper.brokerRecos.stopRecommendationsAutoUpdate = ApiHelper.baseURL + "brokerrecos/stoprecommendationsautoupdate"
ApiHelper.brokerRecos.startOrdersAutoUpdate = ApiHelper.baseURL + "brokerrecos/startordersautoupdate"
ApiHelper.brokerRecos.stopOrdersAutoUpdate = ApiHelper.baseURL + "brokerrecos/stopordersautoupdate"

//Logs
ApiHelper.logs = {}
ApiHelper.logs.addLog = ApiHelper.baseURL + "logs/addlog"
ApiHelper.logs.getStepLogs = ApiHelper.baseURL + "logs/getsteplogs"
ApiHelper.logs.getLogsByOffset = ApiHelper.baseURL + "logs/getlogsbyoffset"
ApiHelper.logs.getBrokerageLogsByOffset = ApiHelper.baseURL + "logs/getbrokeragelogsbyoffset"
//constants
ApiHelper.constants = {}
ApiHelper.constants.constantslist = {
    X: "X",
    Y: "Y"
}
ApiHelper.constants.getAllConstants = ApiHelper.baseURL + "constants/getallconstants"
ApiHelper.constants.getConstantByName = ApiHelper.baseURL + "constants/getconstantbyname"
ApiHelper.constants.updateConstantBySerialId = ApiHelper.baseURL + "constants/updateconstantbyserialid"

//LocalStorage
ApiHelper.localStorage = {}
ApiHelper.localStorage.developerPortal = "developerportal"
//Headers
ApiHelper.getAccessTokenHeaderConfig = () => {
    var token = reactLocalStorage.getObject(ApiHelper.localStorage.developerPortal)
    if(token === undefined){
        reactLocalStorage.clear()
        return {}
    }
    return {
        headers: {
            Authorization: "Bearer " + token.accesstoken
        }
    }
}
ApiHelper.localStorage.logout = () => {
    reactLocalStorage.clear()
}
export default ApiHelper